export const getCars = state => state.techCars.cars;
export const getStatuses = state => state.techCars.statuses;
export const getCarsError = state => state.techCars.carsError;
export const getCarsFetching = state => state.techCars.carsFetching;
export const getSelectedStatus = state => state.techCars.selectedStatus;
export const getQuizPage =  state => state.techCars.quizPagesList[state.techCars.quiz].key;